import type { ReactNode } from 'react';
import { memo } from 'react';
import { Text } from '@library';
import styles from './TireFiltersBlock.module.scss';

const TireFiltersBlock = memo(
    ({ typeCell, children }: { typeCell: ReactNode; children: ReactNode }) => {
        return (
            <>
                <div className={styles.typeCell}>
                    <Text medium> {typeCell}</Text>
                </div>
                {children}
            </>
        );
    }
);
export default memo(TireFiltersBlock);
